export enum Source {
  USER = 'USER',
  SYSTEM = 'SYSTEM',
}
